import { RoutineState } from '../routineState';
import {
  WorkflowResponseState,
  WorkflowAuditLog,
} from './workflowResponseState';

export interface WorkflowRoutineState extends RoutineState {
  responses: WorkflowResponseState[];
  auditLog?: WorkflowAuditLog;
}
